<div class="competitor-modal-wrapper" style="padding: 3em 4.5em; position: relative; max-height: 90vh; overflow-y: auto;">

  <!-- HEADER -->
  <div class="d-flex justify-content-between mx-auto" style="width: 98%">
    <p class="title mb-0 mt-2 pr-5" style="font-family: 'Rubik'; font-size: 30px; font-weight: 500; color: #3f3f3f;">
      {{ data.hotel.title }}
    </p>
    <button type="button" class="close" (click)="onCancel()" aria-label="Close">
      <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
    </button>
  </div>

  <!-- ESTRELLAS -->
  <div class="d-flex align-items-start" style="margin-left: .8em; margin-bottom: .85em;">
    <ng-container *ngFor="let star of [1,2,3,4,5]">
      <img *ngIf="star <= data.hotel.rate" class="mr-1" width="13" height="13"
           src="../../../../assets/icons/itinerary/estrella-01.svg" alt="estrella" />
      <img *ngIf="star > data.hotel.rate" class="mr-1" width="13" height="13"
           style="filter: grayscale(1); opacity: 0.5"
           src="../../../../assets/icons/itinerary/estrella-01.svg" alt="estrella" />
    </ng-container>
  </div>

  <!-- UBICACIÓN -->
  <div style="margin-left: .8em; margin-bottom: 1.5em;">
    <p style="font-family: 'Rubik'; font-size: 14px; font-weight: 600; color: #3f3f3f; margin-bottom: 0;">
      {{ data.hotel.location }}
    </p>
  </div>

  <!-- CARD DE HABITACIÓN (5 columnas x 2 filas) -->
  <div class="card card-info d-flex flex-column mt-3 pb-4 mx-auto" style="width: 100%;border-radius: 12px">
    <div class="room-header" style="position: relative; padding: 35px 2.25em">
      <div class="room-info">
        <p class="room-type pr-5">{{ data?.room?.roomType }}</p>
      </div>
    </div>

    <div class="room-info-grid pt-5 px-5">
      <!-- FILA 1 -->
      <div class="room-info-cell">
        <label class="field-label">Destino</label>
        <p class="field-value">{{ data.payload.city || 'N/A' }}</p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Capacidad</label>
        <p class="field-value d-flex flex-column">
          <span>
            {{ data.room.adults }} {{ data.room.adults === 1 ? 'Adulto' : 'Adultos' }}
          </span>
          <span>
            {{ data.room.childrenCount }} {{ data.room.childrenCount === 1 ? 'Niño' : 'Niños' }}
          </span>
        </p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Check-In</label>
        <p class="field-value">
          {{ data.dates.arrivalDate | date:'d \'de\' MMMM \'de\' yyyy':'':'es' }}
        </p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Condiciones</label>
        <p class="field-value">
          <span [style.color]="data.room.rateClass === 'R' ? '#00d096' : '#ed3b5b'">
            {{ data.room.rateClass === 'R' ? 'Reembolsable' : 'No Reembolsable' }}
          </span>
        </p>
        <span class="field-value" style="color: #00d096; text-decoration: underline;">Ver Politicas</span>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Tarifa por noche</label>
        <p class="field-value" style="font-weight: 600;">
          {{ data.currencyAgency.code }}
          <span style="font-weight: 600;">{{ data.room.netPriceProf | currencyConverterPure: data.room.pricingCurrency: data.currencyAgency.code: data.currencies | number:'1.2-2' }}</span>
          <span style="display: block; font-weight: 400;">Imp. Incluidos</span>
        </p>
      </div>
    </div>

    <hr style="border-width: 2px" class="mx-5" />

    <div class="room-info-grid pb-5 px-5">
      <!-- FILA 2 -->
      <div class="room-info-cell">
        <label class="field-label">Nacionalidad</label>
        <p class="field-value">{{ nationality || 'N/A' }}</p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Cant. habitaciones</label>
        <p class="field-value">{{ data.room.occupancyRoom }}</p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Check-Out</label>
        <p class="field-value">{{ data.dates.departureDate | date:'d \'de\' MMMM \'de\' yyyy':'':'es' }}</p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Régimen</label>
        <p class="field-value">{{ data.room.boardName || 'Room Only' }}</p>
      </div>
      <div class="room-info-cell">
        <label class="field-label">Total Estadía</label>
        <p class="field-value" style="font-weight: 600;">
          {{ data.currencyAgency.code }}
          <span style="font-weight: 600;">{{ data.room.optionNightsNetTotalProf | currencyConverterPure: data.room.pricingCurrency: data.currencyAgency.code: data.currencies | number:'1.2-2' }}</span>
          <span style="font-weight: 400; display: block;">Imp. Incluidos</span>
        </p>
      </div>
    </div>

    <!-- MINTBAND: Competencia / disparidad tarifaria (todo en un bloque mint) -->
    <div class="competitor-mint-band w-100" style="background-color: #85ECB2; padding: 0;">
      <header class="d-flex align-items-stretch" style="gap: 1.25rem; padding: 3rem 3rem 0;">
        <div class="d-flex flex-column justify-content-center">
          <h3 style="font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 600; letter-spacing: -0.01em; color: #171717; margin: 0;">Competencia / disparidad tarifaria</h3>
          <p style="margin: 0.125rem 0 0; font-size: 13px; line-height: 1.35; color: rgba(23,23,23,0.75);">Compartí la tarifa encontrada para que podamos revisarla.</p>
        </div>
      </header>

      <div [formGroup]="competitorForm" style="padding: 1.25rem 3rem 4rem;">

        <!-- Fila 1: Precio encontrado | Moneda | Nombre del hotel -->
        <div class="d-flex" style="gap: 0.75rem;">
          <div class="flex-grow-1" style="width: 33%;">
            <label class="d-block mb-1" style="font-size: 13px; font-weight: 600; color: #171717;">Precio encontrado</label>
            <input type="number" min="0" class="form-control" placeholder="0,00" formControlName="foundPrice"
                   style="background-color: #FFFFFF; border: 1px solid transparent;" />
          </div>
          <div style="min-width: 130px; width: 33%;">
            <label class="d-block mb-1" style="font-size: 13px; font-weight: 600; color: #171717;">Moneda</label>
            <select class="form-control" formControlName="foundCurrency"
                    style="background-color: #FFFFFF; border: 1px solid transparent;">
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="ARS">ARS</option>
              <option value="BRL">BRL</option>
              <option value="GBP">GBP</option>
            </select>
          </div>
          <div class="flex-grow-1" style="width: 33%;">
            <label class="d-block mb-1" style="font-size: 13px; font-weight: 600; color: #171717;">Nombre del hotel</label>
            <input type="text" class="form-control" placeholder="Escribí el nombre del hotel" formControlName="foundHotel" maxlength="100"
                   style="background-color: #FFFFFF; border: 1px solid transparent;" />
          </div>
        </div>

        <!-- Lista de URLs (cada item es un único input, sin precio inline) -->
        <div formArrayName="competitorUrls" class="mt-3">
          <div *ngFor="let urlCtrl of competitorUrlsArray.controls; let i = index"
               class="d-flex align-items-center mb-2" style="gap: 0.5em; width: 100%;">
            <div class="flex-grow-1 w-100">
              <input type="url" class="form-control" placeholder="Pegá el enlace de referencia"
                     [maxLength]="500" [formControlName]="i"
                     style="background-color: #FFFFFF; border: 1px solid transparent;" />
            </div>
            <button *ngIf="i > 0" type="button" (click)="removeCompetitorUrl(i)"
                    class="btn btn-sm" aria-label="Eliminar enlace"
                    style="background-color: #fef2f2; color: #dc2626; min-width: 38px; height: 38px; border: none;"
                    [disabled]="loading">×</button>
          </div>
        </div>

        <!-- Botones de acción -->
        <div class="d-flex flex-wrap mt-2" style="gap: 1.5rem;">
          <button type="button" (click)="addCompetitorUrl()"
                  style="background: transparent; border: none; color: #00d096; font-family: 'Rubik'; font-size: 13px; font-weight: 500; padding: 0;"
                  [disabled]="loading">
            + Agregar otro enlace
          </button>
          <button type="button" (click)="competitorFileInput.click()"
                  style="background: transparent; border: none; color: #171717; opacity: 0.7; font-family: 'Rubik'; font-size: 13px; font-weight: 500; padding: 0;"
                  [disabled]="loading">
            Adjuntar captura
          </button>
          <input #competitorFileInput type="file" accept="image/jpeg,image/png,image/webp" multiple class="d-none"
                 (change)="onCompetitorImagesSelected($event)" />
        </div>

        <!-- Lista de imágenes previsualizadas -->
        <div *ngIf="competitorImagesArray.length > 0" class="d-flex flex-row flex-wrap mt-3" style="gap: 0.5em;">
          <div *ngFor="let img of competitorImagesArray.controls; let i = index"
               class="position-relative" style="width: 96px; height: 96px;">
            <img [src]="'data:image/jpeg;base64,' + img.value"
                 style="width: 96px; height: 96px; object-fit: cover; border-radius: 6px; border: 1px solid #ececec;" />
            <button type="button" (click)="removeCompetitorImage(i)" aria-label="Quitar imagen"
                    style="position: absolute; top: 2px; right: 2px; width: 22px; height: 22px;
                           border-radius: 50%; border: none; background-color: rgba(0,0,0,0.6);
                           color: white; font-size: 12px; line-height: 1; cursor: pointer; padding: 0;"
                    [disabled]="loading">×</button>
          </div>
        </div>

        <!-- Aclaración (opcional) -->
        <div class="mt-4">
          <label class="d-block mb-1" style="font-size: 13px; font-weight: 600; color: #171717;">Aclaración (opcional)</label>
          <textarea class="form-control" rows="4" maxlength="500"
                    formControlName="foundNote"
                    placeholder="Contanos cualquier detalle sobre la tarifa encontrada"
                    style="background-color: #FFFFFF; border: 1px solid transparent;"></textarea>
        </div>

      </div>
    </div>

    <!-- COMENTARIOS Y OVSERVACIONES -->
    <div class="comments-block px-5 py-5">
      <header class="d-flex align-items-stretch mb-3" style="gap: 1.25rem;">
        <div class="d-flex flex-column justify-content-center">
          <h3 class="mb-2" style="font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 600; letter-spacing: -0.01em; color: #171717; margin: 0;">Comentarios y observaciones</h3>
          <p style="margin: 0.125rem 0 0; font-size: 13px; line-height: 1.35; color: rgba(23,23,23,0.6);">Agregá información adicional para tu equipo.</p>
        </div>
      </header>
      <textarea class="form-control" rows="5" maxlength="500" placeholder="Escribí cualquier información adicional que debamos tener en cuenta."
                style="background-color: white; border: 1px solid #e5e5e5;"
                [formControl]="commentsControl"></textarea>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="d-flex justify-content-end mt-4" style="gap: 1em;">
    <button type="button" class="btn"
            style="background-color: #00d096; color: white; font-family: 'Rubik';
                   font-size: 14px; font-weight: 600; padding: 0.5em 2em; border: none;"
            (click)="onSave()" [disabled]="loading">
      <span *ngIf="!loading">Enviar</span>
      <span *ngIf="loading" class="d-flex align-items-center" style="gap: 0.4em;">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Enviando...
      </span>
    </button>
  </div>

</div>
